import classNames from 'classnames'
import Button from 'react-bootstrap/Button'

import Img from 'components/ui/Img'
import fullscreen from 'assets/icons/fullscreen.svg'
import fullscreenExit from 'assets/icons/fullscreen_exit.svg'
import styles from './Buttons.module.scss'

export const Buttons = ({ isFullscreen, onClick }) => {
  return (
    <div className={classNames(styles.container)}>
      <Button
        className="border-dark"
        variant="outline-light"
        size="sm"
        onClick={onClick}
      >
        <Img src={isFullscreen ? fullscreenExit : fullscreen} />
      </Button>
    </div>
  )
}
